import { theme } from 'antd';
import { useEffect } from 'react';

import { LoadingAnimation } from 'components/loading/LoadingAnimation';

import { useNotification } from 'hooks/utils/useNotification';

import { useLoadingStore, useSnackStore } from 'store/index';

function Loader() {
  const { token } = theme.useToken();
  const notification = useNotification();
  const { loading, title, description } = useLoadingStore();
  const { open, type, message } = useSnackStore();

  useEffect(() => {
    if (open) {
      if (type === 'success') {
        notification.success({ title: 'Success', description: message });
      } else {
        notification.error({ title: 'Error', description: message });
      }
    }
  }, [open, type, message, notification]);

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm ${
        loading ? 'visible' : 'invisible'
      }`}
      style={{
        backgroundColor: `${token.colorBgContainer}80`,
      }}
    >
      <div className="text-center">
        <p className="font-medium mb-2" style={{ color: token.colorPrimary }}>
          {title}
        </p>

        <p className="text-sm mb-4">{description}</p>

        <LoadingAnimation
          style={{ width: '150px', height: '150px', margin: 'auto' }}
        />
      </div>
    </div>
  );
}

export { Loader };
